module.exports = __webpack_public_path__ + "img/fbff428.jpg";